export enum CardShadows {
  NONE = 'none',
  SMALL = 'small',
  LARGE = 'large',
}

export enum CardBorderRadius {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export enum CardBorderColor {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  BORDER = 'border-secondary',
}
